import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getPageIdInfo } from "../utils/common";
import lego from "../lego";
import Logger from "../utils/log";
var hitPageId = function hitPageId() {
  if (location.href.indexOf('/good-price-zone') > -1) {
    return 'U1205';
  }
  if (location.href.indexOf('/zz-platform-pages/history') > -1) {
    return 'V4961'; // 足迹
  }
  return '';
};
var AREA_ATTR_NAME = 'data-areaexposure'; // 可见元素的属性名
var SECTION_ID_NAME = 'zz-sectionid';
var BACK_UP_NAME = 'lego-area-backup'; // 备份属性名
var ZZ_BACKUP = 'zz-backup';
var DATA_ISDOT = 'data-isdot'; // isdot属性名
var NO_SEND_EXPOSE = 'zz-nosendAreaExposure'; // 不发送的属性名

// "backup"对象的接口，包含在LEGO指标中

var targetArr = []; // 可见元素的数组
var targetArrOld = []; // 旧的可见元素的数组
var targetArrNew = []; // 新的可见元素的数组
var extraParams = {}; // 额外的LEGO指标参数
var observer = null; // IntersectionObserver对象
var hasExposure = []; // 已经曝光的指标
var pageIdInfo = {}; // 页面信息
var cacheCallback = function cacheCallback() {};

// 常规模式下发送LEGO指标
// 发送LEGO指标的逻辑
var legoLog = function legoLog(ctx) {
  var _pageIdInfo;
  var uid = ctx.uid,
    metric = ctx.metric,
    isdot = ctx.isdot,
    backupParamObj = ctx.backupParamObj;
  // 不再上报已经曝光的指标
  if (hasExposure.indexOf(uid) !== -1) {
    return;
  }
  hasExposure.push(uid);
  var params = _objectSpread({}, extraParams);
  params.pagetype = 'Areaexposure'; // 页面类型
  params.actiontype = (_pageIdInfo = pageIdInfo) === null || _pageIdInfo === void 0 ? void 0 : _pageIdInfo.pageId; // 页面ID
  params.backup = _objectSpread({
    sectionId: metric,
    // 段ID
    isdot: isdot
  }, backupParamObj);
  if (!params.actiontype) {
    Logger.error('请配置pageId'); // 请确保页面ID已设置
    if (hitPageId()) {
      lego.send({
        actiontype: hitPageId(),
        pagetype: 'test-lego-setPageId'
      });
    }
    return;
  }
  lego.send(params, cacheCallback); // 发送LEGO指标
};

// 元素出现在可视区域时的操作逻辑
var observerLogic = function observerLogic(entries) {
  // console.log('entries', entries)
  var ctx = {};
  entries.forEach(function (entry) {
    if (hitPageId()) {
      if (entry.target.getAttribute('zz-sectionid') === '888' && window['LEGO_VERIFY_Obj']['test-lego-observerLogicSendAll-area'] != 1) {
        window['LEGO_VERIFY_Obj']['test-lego-observerLogicSendAll-area'] = 1;
        lego.send({
          actiontype: hitPageId(),
          pagetype: 'test-lego-observerLogicSendAll-area'
        });
      }
      if (entry.target.getAttribute('zz-sectionid') === '777' && window['LEGO_VERIFY_Obj']['test-lego-observerLogicSendAll-area-000'] != 1) {
        window['LEGO_VERIFY_Obj']['test-lego-observerLogicSendAll-area-000'] = 1;
        lego.send({
          actiontype: hitPageId(),
          pagetype: 'test-lego-observerLogicSendAll-area-000'
        });
      }
    }
    // 元素至少50%可见
    if (entry.intersectionRatio && entry.intersectionRatio > 0) {
      ctx.metric = entry.target.getAttribute(AREA_ATTR_NAME) || entry.target.getAttribute(SECTION_ID_NAME); // 可见元素的指标
      ctx.isdot = entry.target.getAttribute(DATA_ISDOT); // 是否是dot
      ctx.backupParam = entry.target.getAttribute(BACK_UP_NAME) || entry.target.getAttribute(ZZ_BACKUP) || '{}'; // 备份参数
      ctx.uid = ctx.metric + ctx.backupParam; // 唯一标识

      try {
        ctx.backupParamObj = JSON.parse(ctx.backupParam); // 将备份参数解析为JS对象
      } catch (e) {
        if (hitPageId()) {
          lego.send({
            actiontype: hitPageId(),
            pagetype: 'test-lego-backupError'
          });
        }
        Logger.error('[Lego - legoAreaExposure] lego-backup参数格式错误，无法解析成JS对象'); // 备份参数格式错误
      }
      if (ctx.metric) {
        legoLog(ctx); // 发送LEGO指标
      } else {
        if (hitPageId()) {
          lego.send({
            actiontype: hitPageId(),
            pagetype: 'test-lego-noMetric'
          });
        }
      }
      if (hitPageId()) {
        if (entry.target.getAttribute('zz-sectionid') === '888' && window['LEGO_VERIFY_Obj']['test-lego-observerLogicSend'] != 1) {
          window['LEGO_VERIFY_Obj']['test-lego-observerLogicSend'] = 1;
          lego.send({
            actiontype: hitPageId(),
            pagetype: 'test-lego-observerLogicSend'
          });
        }
        if (entry.target.getAttribute('zz-sectionid') === '777' && window['LEGO_VERIFY_Obj']['test-lego-observerLogicSend-000'] != 1) {
          window['LEGO_VERIFY_Obj']['test-lego-observerLogicSend-000'] = 1;
          lego.send({
            actiontype: hitPageId(),
            pagetype: 'test-lego-observerLogicSend-000'
          });
        }
      }
    }
    // else {
    //   if (hitPageId()) {
    //     if(entry.target.getAttribute('zz-sectionid') === '888'){
    //       lego.send({
    //         actiontype: hitPageId(),
    //         pagetype: 'test-lego-observerLogicSendNoIntersectionRatio'
    //       });
    //     }
    //     if(entry.target.getAttribute('zz-sectionid') === '777'){
    //       lego.send({
    //         actiontype: hitPageId(),
    //         pagetype: 'test-lego-observerLogicSendNoIntersectionRatio-000'
    //       });
    //     }
    //   }
    // }
  });
};

// 导出调用函数
export default (function (legoParams, callback) {
  try {
    if (typeof window === 'undefined') return; // 如果是服务器端，则不运行
    // Logger.info(`lego面积曝光埋点lego-area-exposure`)
    extraParams = legoParams || {}; // 设置额外的LEGO指标参数
    cacheCallback = callback ? callback : cacheCallback;
    targetArrOld = document.querySelectorAll("[".concat(AREA_ATTR_NAME, "]")); // 获取可见元素的数组
    targetArrNew = new Set(Array.from(document.querySelectorAll("[".concat(SECTION_ID_NAME, "]")))); // 获取可见元素的数组
    targetArrNew.forEach(function (item) {
      // 处理特殊case 禁止上报区域
      if (item.getAttribute(NO_SEND_EXPOSE) === '1') targetArrNew.delete(item);
    });
    targetArr = [].concat(_toConsumableArray(targetArrOld), _toConsumableArray(targetArrNew));
    pageIdInfo = getPageIdInfo(); // 获取页面信息

    if (!pageIdInfo) {
      return; // 如果没有页面信息，则不运行
    }
    // const ioPromise = checkIntersectionObserver()
    //   ? Promise.resolve()
    //   : import('intersection-observer')

    // ioPromise.then(() => {
    //   // 先断开再监听，避免重复监听的情况
    //   if (observer) observer.disconnect()
    //   // IntersectionObserver方法的处理逻辑
    //   observer = new IntersectionObserver(observerLogic, {
    //     threshold: [0.01, 0.25, 0.5, 0.75, 1] // 元素50%显示时，即视为可见
    //   })

    //   if (hitPageId()) {
    //     const have888 = targetArr.find((item)=>{
    //       return item?.getAttribute('zz-sectionid')==='888'
    //     })
    //     const have777 = targetArr.find((item)=>{
    //       return item?.getAttribute('zz-sectionid')==='777'
    //     })
    //     if(have888 && window['LEGO_VERIFY_Obj']['test-lego-have888'] != 1){
    //       window['LEGO_VERIFY_Obj']['test-lego-have888'] = 1
    //       lego.send({
    //         actiontype: hitPageId(),
    //         pagetype: 'test-lego-have888'
    //       })
    //     }
    //     // else{
    //     //   lego.send({
    //     //     actiontype: hitPageId(),
    //     //     pagetype: 'test-lego-haveNot888'
    //     //   })
    //     // }
    //     if(have777 && window['LEGO_VERIFY_Obj']['test-lego-have777'] != 1){
    //       window['LEGO_VERIFY_Obj']['test-lego-have777'] = 1
    //       lego.send({
    //         actiontype: hitPageId(),
    //         pagetype: 'test-lego-have777'
    //       })
    //     }
    //   }

    //   // 监听可见元素
    //   ;(targetArr as any).forEach((target) => {
    //     observer.observe(target)
    //   })
    // })

    // 如果浏览器支持IntersectionObserver，则直接使用；否则加载IntersectionObserver模块
    // require('../utils/intersection-observer.js')
    // TODO: 临时注释
    require("../utils/intersection-observer-debug.js");
    // if (hitPageId()) {
    //   if(!('IntersectionObserver' in window)){
    //     lego.send({
    //       actiontype: hitPageId(),
    //       pagetype: 'test-lego-loseIntersectionObserver'
    //     })
    //   }
    //   if(!('IntersectionObserverEntry' in window)){
    //     lego.send({
    //       actiontype: hitPageId(),
    //       pagetype: 'test-lego-loseIntersectionObserverEntry'
    //     })
    //   }
    //   if(!('intersectionRatio' in window.IntersectionObserverEntry.prototype)){
    //     lego.send({
    //       actiontype: hitPageId(),
    //       pagetype: 'test-lego-loseIntersectionRatio'
    //     })
    //   }
    //   if(!('isIntersecting' in window.IntersectionObserverEntry.prototype)){
    //     lego.send({
    //       actiontype: hitPageId(),
    //       pagetype: 'test-lego-loseIsIntersecting'
    //     })
    //   }
    // }
    // 先断开再监听，避免重复监听的情况
    if (observer) observer.disconnect();
    // IntersectionObserver方法的处理逻辑
    observer = new IntersectionObserverAdapter(observerLogic, {
      threshold: [0.01, 0.25, 0.5, 0.75, 1] // 元素50%显示时，即视为可见
    })
    // TODO:
    // observer = new IntersectionObserver(observerLogic, {
    //   threshold: 0.5 // 元素50%显示时，即视为可见
    // })

    // if (hitPageId()) {
    //   const have888 = targetArr.find((item)=>{
    //     return item?.getAttribute('zz-sectionid')==='888'
    //   })
    //   const have777 = targetArr.find((item)=>{
    //     return item?.getAttribute('zz-sectionid')==='777'
    //   })
    //   if(have888){
    //     lego.send({
    //       actiontype: hitPageId(),
    //       pagetype: 'test-lego-have888'
    //     })
    //   }else{
    //     lego.send({
    //       actiontype: hitPageId(),
    //       pagetype: 'test-lego-haveNot888'
    //     })
    //   }
    //   if(have777){
    //     lego.send({
    //       actiontype: hitPageId(),
    //       pagetype: 'test-lego-have777'
    //     })
    //   }
    // }

    // 监听可见元素
    ;
    targetArr.forEach(function (target) {
      // TODO: 临时删除定时器
      // observer.observe(target)
      observer.observe(target);
    });
  } catch (error) {
    Logger.error("lego\u521D\u59CB\u5316\u9762\u79EF\u66DD\u5149\u57CB\u70B9lego-area-exposure\u62A5\u9519".concat(error));
    if (hitPageId()) {
      lego.send({
        actiontype: hitPageId(),
        pagetype: 'test-lego-areaExposureError'
      });
    }
  }
});